export const translations = {
  es: {
    nav: {
      tech: "Logística",
      services: "Servicios",
      recovery: "Recuperaciones",
      corporate: "Flotas",
      howItWorks: "Cómo funciona",
      faq: "FAQ",
      contact: "Contacto",
      callNow: "Cotizar",
      login: "Acceso equipo"
    },
    topBanner: "Sistema AutoGo · Recuperación Premium 24/7",
    hero: {
      tagline: "SISTEMA AUTOGO",
      title: "Transporte de vehículos",
      titleHighlight: "a otro nivel.",
      description: "Logística de precisión, seguimiento en tiempo real y entrega blindada para tu vehículo en toda España y Europa.",
      verified: "Transportistas verificados",
      insured: "Seguro a todo riesgo",
      delivery: "Entrega 24/72h",
      formTitle: "Cotiza en 30 segundos",
      formSubtitle: "Respuesta humana en menos de 15 minutos",
      pickupLocation: "Origen",
      pickupPlaceholder: "Ciudad de recogida",
      deliveryLocation: "Destino",
      deliveryPlaceholder: "Ciudad de entrega",
      pickupDate: "Fecha recogida",
      deliveryDate: "Fecha entrega",
      vehicleType: "Vehículo",
      vehiclePlaceholder: "Turismo, furgoneta, SUV…",
      name: "Nombre",
      namePlaceholder: "Tu nombre",
      email: "Email",
      emailPlaceholder: "tu@email.com",
      phone: "Teléfono",
      phonePlaceholder: "+34 930 49 15 01",
      submit: "Solicitar cotización",
      whatsappBtn: "Cotizar por WhatsApp",
      successTitle: "¡Solicitud enviada!",
      successDescription: "Te contactaremos en menos de 15 minutos con tu cotización personalizada.",
      errorTitle: "Error",
      errorDescription: "Hubo un problema al enviar tu solicitud. Inténtalo de nuevo o escríbenos por WhatsApp.",
      dateOrderErrorTitle: "Revisa las fechas",
      dateOrderErrorDescription: "La fecha de entrega debe ser el mismo día o posterior a la fecha de recogida."
    },
    miniMockup: {
      route: "Ruta activa",
      eta: "ETA",
      etaTime: "14:30",
      weather: "Soleado · 22°C",
      city1: "Madrid",
      city2: "Barcelona",
      live: "EN VIVO"
    },
    dashboard: {
      tag: "MI PANEL",
      greeting: "Hola, Carlos",
      client: "Cliente #4821",
      activeShipment: "Envío activo",
      shipmentRoute: "Madrid → Barcelona",
      progressLabel: "Progreso",
      stages: ["Recogida", "En ruta", "Entrega"],
      stageActive: 1,
      services: "Servicios activos",
      svc1: "SmartTrack 360",
      svc2: "Inspección 360°",
      svc3: "SecurePIN",
      svc4: "Alertas",
      stat1: "Próx. entrega",
      stat1v: "Hoy 14:30",
      stat2: "Vehículos",
      stat2v: "1 en ruta"
    },
    inspectionMock: {
      angles: ["FRONTAL", "IZQ.", "DCHA.", "TRAS."],
      report: "Informe",
      reportData: "PDF · 24 fotos",
      ready: "LISTO",
      status: "Estado vehículo",
      statusOk: "3/4 OK",
      areas: [
        { area: "Carrocería", ok: true },
        { area: "Cristales", ok: true },
        { area: "Puerta DCHA", ok: false },
        { area: "Llantas", ok: true }
      ],
      timeline: "Cronología",
      now: "Hoy · 14:30",
      stages: [
        { stage: "Pre-ruta", time: "12:30", done: true },
        { stage: "Carga", time: "12:45", done: true },
        { stage: "Post-ruta", time: "14:28", done: true },
        { stage: "Entrega", time: "Pendiente", done: false }
      ]
    },
    pinMock: {
      verified: "PIN verificado",
      verifiedTime: "Hoy · 14:32",
      ok: "OK",
      receiver: "Carlos Martínez",
      receiverDoc: "DNI ****12345"
    },
    differentiators: {
      tagline: "LOGÍSTICA AUTOGO",
      title: "No solo transportamos.",
      titleAccent: "Monitorizamos cada kilómetro.",
      subtitle: "Una plataforma propia que eleva el transporte de vehículos de estándar a premium.",
      pillars: {
        track: {
          name: "SmartTrack 360",
          desc: "Seguimiento satelital en vivo, ETA exacto y meteorología en destino. Tu coche, siempre en pantalla.",
          tag: "TRACKING"
        },
        check: {
          name: "Inspección 360°",
          desc: "Revisión digital exhaustiva antes y después de cada ruta. Documentación visual completa.",
          tag: "INSPECCIÓN"
        },
        panel: {
          name: "Panel Cliente",
          desc: "Toda tu operativa en un solo lugar: pedido activo, servicios y entregas. Acceso 24/7.",
          tag: "PANEL"
        },
        pin: {
          name: "Verificación SecurePIN",
          desc: "Código único de entrega. Tu vehículo solo se libera ante quien tiene el PIN.",
          tag: "ENTREGA"
        },
        alerts: {
          name: "Alertas Proactivas",
          desc: "Notificaciones automáticas en cada hito clave: recogida, ruta, llegada y entrega.",
          tag: "AVISOS"
        }
      }
    },
    services: {
      tagline: "QUÉ HACEMOS",
      title: "Soluciones completas de transporte.",
      list: [
        { title: "Transporte Nacional", desc: "Coches y furgonetas a cualquier punto de España. Cobertura completa peninsular." },
        { title: "Transporte Internacional", desc: "Llevamos tu vehículo a cualquier país de Europa con garantía total y seguimiento activo." },
        { title: "Transporte de Flotas", desc: "Soluciones B2B para empresas, concesionarios y financieras con gestión integral." },
        { title: "Servicios Premium", desc: "Limpieza pre-entrega, gestión de ITV y check-up mecánico antes de salir." }
      ]
    },
    operatingMargin: {
      tag: "EXCLUSIVO PARA FLOTAS",
      ribbon: "FLEET PROGRAM",
      name: "Tarifa flota",
      titleLine1: "Tarifa",
      titleLine2: "flota.",
      slogan: "Transforma tu logística en beneficio neto.",
      description: "Tarifa blindada y hasta −10% de ahorro directo en cada traslado. Una factura. Cero gestión extra.",
      homeHeadline1: "Mueve más.",
      homeHeadline2: "Paga menos.",
      homeWidgetLabel: "AHORRO DIRECTO",
      homeWidgetUpTo: "Hasta",
      homeWidgetBig: "−10%",
      homeWidgetUnit: "GARANTIZADO · EN CADA TRASLADO",
      homeWidgetMoney: "≈ €4.280",
      homeWidgetMoneyLabel: "AHORRO MEDIO · FLOTA TIPO · YTD",
      seal: "AHORRO GARANTIZADO",
      sealRotation: "FLEET • PROGRAM • PREMIUM • ",
      compareTitle: "Tu margen, en visión",
      compareStandard: "Operativa estándar",
      compareOM: "Con Tarifa flota",
      compareNote: "Curva orientativa. Tu propuesta es 100% personalizada.",
      benefits: [
        { title: "Tarifa blindada", desc: "Bloquea tu coste anual sin sorpresas." },
        { title: "Una sola factura", desc: "Olvida los presupuestos por traslado." },
        { title: "Hasta 10% ahorro", desc: "Directo sobre nuestra red completa." },
        { title: "Control total", desc: "Gestor dedicado y panel de operativa." }
      ],
      formTitle: "Solicita tu propuesta",
      formSubtitle: "Recibirás un plan personalizado en menos de 24h.",
      cardLabel: "FLEET MEMBER",
      cardId: "OM • CORPORATE",
      company: "Empresa",
      companyPlaceholder: "Nombre de tu empresa",
      contactName: "Tu nombre",
      contactNamePlaceholder: "Persona de contacto",
      email: "Email corporativo",
      emailPlaceholder: "tu@empresa.com",
      phone: "Teléfono",
      phonePlaceholder: "+34 ...",
      annualKm: "Volumen anual estimado",
      annualKmPlaceholder: "p.ej. 50.000 km / 80 traslados",
      notes: "Comentarios (opcional)",
      notesPlaceholder: "Cuéntanos brevemente tu operativa…",
      submit: "Solicitar propuesta",
      whatsapp: "Hablar con ventas",
      restricted: "ACCESO BAJO SOLICITUD · SOLO PARA FLOTAS ACTIVAS",
      successTitle: "Solicitud recibida",
      successDescription: "Te enviaremos una propuesta personalizada en menos de 24h.",
      errorTitle: "Error",
      errorDescription: "No hemos podido enviar la solicitud. Inténtalo de nuevo o por WhatsApp."
    },
    fleetSaveLanding: {
      meta: {
        title: "Tarifa flota — Ahorra hasta 10% en cada traslado | AutoGo Delivery",
        description: "Programa exclusivo Fleet Save para concesionarios, renting y flotas corporativas. Hasta -10% por traslado, factura única mensual, gestor dedicado 24/7. Propuesta personalizada en 24h."
      },
      backHome: "Volver al inicio",
      brandTag: "FLEET SAVE",
      topBanner: "Programa Tarifa flota · Ahorro directo hasta -10% · Ahorro real desde el primer día",
      navCta: "Solicitar propuesta",
      hero: {
        badge: "PROGRAMA EXCLUSIVO · FLOTAS",
        title: "Cada traslado que",
        titleAccent1: "pagas de más",
        titleMiddle: "es margen que",
        titleAccent2: "pierdes.",
        description: "Tarifa flota es el programa de AutoGo para empresas con traslados frecuentes. Una sola factura al mes, tarifa blindada y hasta 10% de ahorro directo sobre toda nuestra red europea.",
        ctaPrimary: "Solicitar propuesta",
        ctaSecondary: "Ver cómo funciona",
        trust: ["Ahorro real desde el primer día", "Propuesta en 24h", "NDA si aplica"]
      },
      anchors: {
        tagline: "TRES NÚMEROS QUE LO RESUMEN",
        savingsUpTo: "Hasta",
        items: [
          { v: "−10%", l: "Ahorro por traslado", d: "Aplicado directo desde el primer viaje sobre nuestra red completa." },
          { v: "1", l: "Factura mensual", d: "Una sola factura con todos los traslados. Olvida el presupuesto por cada viaje." },
          { v: "24/7", l: "Gestor dedicado", d: "Un único punto de contacto que conoce tu operativa y responde sin esperas." }
        ]
      },
      calc: {
        tagline: "CALCULADORA DE AHORRO",
        title: "Calcula tu ahorro",
        titleAccent: "en 10 segundos.",
        subtitle: "Mueve los sliders con tu operativa real y mira el margen que podrías recuperar este año.",
        transfersLabel: "Traslados al mes",
        transfersHint: "Media histórica de tu flota",
        kmLabel: "Distancia media (km)",
        kmHint: "Por traslado · ida simple",
        outputLabel: "Tu ahorro estimado anual",
        outputUnit: "EUR / AÑO",
        outputDetail: "Equivale a",
        outputDetailSuffix: "€ al mes de ahorro directo.",
        note: "Cálculo orientativo. Tu propuesta final es 100% personalizada según ruta, vehículo y volumen.",
        ctaSecondary: "Hablar por WhatsApp",
        ctaPrimary: "Solicitar mi propuesta",
        monthlyTransfers: "traslados / mes",
        kmShort: "km"
      },
      how: {
        tagline: "CÓMO FUNCIONA",
        title: "Tres pasos.",
        titleAccent: "Sin fricción operativa.",
        subtitle: "Simplifica tus procesos internos",
        steps: [
          { num: "01", title: "Solicitas propuesta", desc: "Nos cuentas volumen, rutas tipo y vehículos. En 24h te enviamos plan personalizado.", bullets: ["Propuesta en 24h", "Sin compromiso", "Acceso bajo NDA"] },
          { num: "02", title: "Activas tu crédito de km", desc: "Bloqueas tu tarifa anual y activas tu crédito. Tu equipo empieza a operar igual que antes.", bullets: ["Tarifa blindada", "Alta en 48h", "Gestor dedicado"] },
          { num: "03", title: "Usas y facturas mensual", desc: "Tu equipo pide traslados con total normalidad. Una sola factura consolidada al mes.", bullets: ["Una factura", "Panel de uso", "Reporte por unidad"] }
        ]
      },
      forWho: {
        tagline: "PARA QUIÉN ES",
        title: "Diseñado para quien mueve",
        titleAccent: "coches cada mes.",
        list: [
          { title: "Concesionarios", desc: "Stock rotante entre sedes, traslados a clientes finales y retirada de unidades ex-demo." },
          { title: "Renting & Leasing", desc: "Altas, bajas y cambios de conductor con recogidas y entregas coordinadas por toda Europa." },
          { title: "Flotas corporativas", desc: "Grandes empresas con traslados recurrentes de unidades de empresa, directivos o talleres." }
        ]
      },
      cardSection: {
        tagline: "EL PRODUCTO EN USO REAL",
        title: "Así ve tu equipo",
        titleAccent: "el programa cada mes.",
        subtitle: "Tarjeta Fleet Member en tiempo real: ahorro acumulado, traslados consumidos del plan y tarifa bloqueada.",
        bullets: [
          "Panel accesible 24/7 por todo el equipo autorizado",
          "Exportable a tu ERP o sistema de gestión",
          "Reporte mensual consolidado en PDF"
        ]
      },
      testimonials: {
        tagline: "LO QUE DICEN NUESTRAS FLOTAS",
        title: "Resultados reales,",
        titleAccent: "no teoría.",
        items: [
          {
            quote: "Con Tarifa flota hemos pasado de 40 presupuestos al mes a una sola factura consolidada. El ahorro en tiempo administrativo ya justifica el programa, y encima recortamos un 9% en coste de traslado.",
            name: "María L.",
            role: "Directora de Operaciones",
            company: "Grupo concesionario · Cataluña"
          },
          {
            quote: "Movemos entre 60 y 80 coches al mes en renting. Pasar a AutoGo con el programa Fleet Save nos ha dado previsibilidad de coste y un gestor que conoce nuestros procesos. Cero sorpresas.",
            name: "Javier R.",
            role: "Fleet Manager",
            company: "Renting B2B · Madrid"
          }
        ],
        note: "Testimonios reales. Empresa completa bajo NDA a disposición en la llamada."
      },
      form: {
        tagline: "SOLICITAR PROPUESTA",
        title: "Recibe tu propuesta",
        titleAccent: "en 24 horas.",
        subtitle: "Cinco campos. Sin compromiso. Plan personalizado para tu volumen real.",
        company: "Empresa",
        companyPlaceholder: "Nombre de tu empresa",
        name: "Persona de contacto",
        namePlaceholder: "Tu nombre",
        email: "Email corporativo",
        emailPlaceholder: "tu@empresa.com",
        phone: "Teléfono",
        phonePlaceholder: "+34 ...",
        monthlyTransfers: "Traslados aproximados al mes",
        monthlyTransfersPlaceholder: "p.ej. 25",
        submit: "Recibir mi propuesta en 24h",
        whatsapp: "Hablar con ventas por WhatsApp",
        nda: "Confidencialidad garantizada · NDA disponible",
        successTitle: "Propuesta en camino",
        successDescription: "Un gestor revisará tu caso y te llamará en menos de 24h con tu plan personalizado.",
        errorTitle: "Error",
        errorDescription: "No hemos podido enviar la solicitud. Inténtalo de nuevo o por WhatsApp."
      }
    },
    recovery: {
      badge: "OPERACIONES ESPECIALES · 24/7",
      title: "Recuperación de vehículos",
      titleAccent: "en toda Europa.",
      description: "Líderes europeos en recuperación y traslado profesional de vehículos: alquileres no devueltos, fin de contrato y situaciones complejas. Procedimiento legal, discreto y efectivo.",
      points: [
        { title: "Devoluciones B2B", desc: "Recuperación de unidades pendientes de devolver con custodia documental." },
        { title: "Alquiler no devuelto", desc: "Localización y recuperación en cualquier país europeo." },
        { title: "Cobertura Europea", desc: "Red internacional de profesionales especializados." }
      ],
      btn1: "Recuperación Urgente",
      btn2: "Consulta confidencial",
      stats: [
        { v: "24/7", l: "Disponibilidad" },
        { v: "100%", l: "Legal" },
        { v: "EU", l: "Cobertura" }
      ]
    },
    howItWorks: {
      tagline: "CÓMO FUNCIONA",
      title: "Cuatro pasos.",
      titleAccent: "Cero fricción.",
      subtitle: "Un flujo diseñado para que solo tengas que confirmar y recibir.",
      steps: [
        { num: "01", title: "Cotiza", desc: "Presupuesto transparente en minutos.", bullets: ["Respuesta < 15 min", "Sin compromiso", "Web o WhatsApp"] },
        { num: "02", title: "Pre-Check", desc: "Inspección 360° y recogida coordinada.", bullets: ["Fotos 360°", "Documentación visual", "Recogida puerta a puerta"] },
        { num: "03", title: "En ruta", desc: "Tracking activo y alertas en tiempo real.", bullets: ["GPS satelital", "ETA exacto + clima", "Alertas proactivas"] },
        { num: "04", title: "Entrega", desc: "Validación con SecurePIN y documentación.", bullets: ["PIN único de entrega", "Firma digital", "Informe PDF final"] }
      ]
    },
    stats: {
      vehicles: "10K+",
      vehiclesLabel: "Vehículos entregados",
      satisfaction: "98%",
      satisfactionLabel: "Clientes satisfechos",
      delivery: "24-72h",
      deliveryLabel: "Tiempo medio de entrega",
      coverage: "EU",
      coverageLabel: "Cobertura internacional"
    },
    clients: {
      tagline: "CONFÍAN EN AUTOGO",
      subtitle: "Concesionarios · Financieras · Aseguradoras · Renting"
    },
    quickAccess: {
      tagline: "ACCESO RÁPIDO",
      title: "¿Qué necesitas hoy?",
      cards: [
        {
          tag: "OPERACIONES 24/7 · EUROPA",
          title: "Recuperación",
          highlight: "de vehículos",
          desc: "Servicio premium para financieras, leasing y concesionarios. Procedimiento legal en toda Europa.",
          cta: "Ver Recuperación",
          to: "/recuperacion",
          featured: true
        },
        {
          tag: "TRANSPORTE",
          title: "Estándar &",
          highlight: "Premium",
          desc: "Coches, furgonetas y SUV. Cobertura nacional e internacional con seguimiento activo.",
          cta: "Cotizar",
          to: "#hero"
        },
        {
          tag: "FLOTAS B2B",
          title: "Tarifa",
          highlight: "flota",
          desc: "Programa exclusivo con hasta 10% de ahorro y tarifa blindada para volúmenes.",
          cta: "Ver Tarifa flota",
          to: "/flotas",
          discount: "−10%",
          discountLabel: "AHORRO"
        }
      ]
    },
    additional: {
      tagline: "EXTRAS",
      title: "Más que transporte.",
      list: [
        { title: "ITV & Homologación", desc: "Gestionamos la ITV antes del transporte." },
        { title: "Limpieza Integral", desc: "Tu vehículo entregado como nuevo." },
        { title: "Pit Stop Técnico", desc: "Niveles, presión, luces y frenos revisados." },
        { title: "Representaciones", desc: "Para financieras y concesionarios." }
      ]
    },
    faq: {
      tagline: "PREGUNTAS FRECUENTES",
      title: "Lo que necesitas saber.",
      subtitle: "Respuestas claras y directas. Si no encuentras la tuya, escríbenos.",
      contactBtn: "Contáctanos por WhatsApp"
    },
    footer: {
      description: "Transporte y recuperación premium de vehículos en España y Europa.",
      quickLinks: "Navegación",
      contact: "Contacto",
      legal: "Legal",
      whatsapp: "WhatsApp",
      rights: "© 2025 AutoGo Delivery · Todos los derechos reservados.",
      privacyPolicy: "Política de Privacidad",
      cookiesPolicy: "Política de Cookies"
    },
    recoveryLanding: {
      meta: {
        title: "Recuperación de vehículos en toda Europa | AutoGo Delivery",
        description: "Servicio premium de recuperación y traslado de vehículos: leasing, alquileres no devueltos y final de contrato. Procedimiento legal, discreto y efectivo en toda Europa. 24/7."
      },
      backHome: "Volver al inicio",
      hero: {
        badge: "OPERACIONES ESPECIALES · 24/7 · EUROPA",
        title: "Recuperación de vehículos",
        titleAccent: "sin fricción legal.",
        description: "El servicio que financieras, concesionarios, leasing, renting y aseguradoras eligen para localizar y recuperar vehículos en toda Europa. Procedimiento legal, discreto y rastreado en tiempo real.",
        ctaPrimary: "Activar recuperación urgente",
        ctaSecondary: "Hablar por WhatsApp",
        trust: ["100% Legal", "Cobertura UE", "Reportes con foto y firma", "24/7 disponible"]
      },
      stats: [
        { v: "24/7", l: "Activación inmediata" },
        { v: "27", l: "Países con red activa" },
        { v: "<48h", l: "Tiempo medio de recuperación" },
        { v: "100%", l: "Procedimiento legal" }
      ],
      forWho: {
        tagline: "PARA QUIÉN",
        title: "Diseñado para los que",
        titleAccent: "no pueden esperar.",
        list: [
          { title: "Financieras", desc: "Recuperación y traslado seguro de unidades en cualquier punto de Europa, con custodia documental." },
          { title: "Concesionarios", desc: "Vehículos en demostración, leasing operativo o ventas no liquidadas." },
          { title: "Renting & Leasing", desc: "Localización europea de unidades fuera de plazo o no devueltas." },
          { title: "Aseguradoras", desc: "Vehículos siniestrados, robados o pendientes de peritación." }
        ]
      },
      cases: {
        tagline: "CUÁNDO LLAMARNOS",
        title: "Casos que resolvemos a diario.",
        items: [
          { tag: "RECOGIDA URGENTE", title: "Recogida urgente B2B", desc: "Localización y recogida con plazo crítico en cualquier punto de Europa, con custodia documental completa." },
          { tag: "ALQUILER", title: "Renting/alquiler no devuelto", desc: "Búsqueda en cualquier país europeo y traslado seguro a tu sede o stock." },
          { tag: "FIN DE CONTRATO", title: "Final de leasing/renting", desc: "Recogida programada al término del contrato y traslado a tu sede o stock con informe completo." },
          { tag: "FUGA UE", title: "Vehículo fuera de España", desc: "Red de socios certificados en 27 países UE para gestión transfronteriza." }
        ]
      },
      how: {
        tagline: "CÓMO FUNCIONA",
        title: "De llamada a recuperación.",
        titleAccent: "En 4 fases.",
        steps: [
          { num: "01", title: "Activación", desc: "Recibimos el caso 24/7 y abrimos expediente con tu gestor dedicado." },
          { num: "02", title: "Localización", desc: "Nuestra red europea localiza el vehículo y verifica situación legal." },
          { num: "03", title: "Recuperación", desc: "Operativa de campo en cualquier punto de Europa con custodia documental completa." },
          { num: "04", title: "Entrega", desc: "Traslado seguro a tu sede, stock o depósito con informe completo y trazado." }
        ]
      },
      whyUs: {
        tagline: "POR QUÉ AUTOGO",
        title: "Nadie recupera como AutoGo.",
        points: [
          { title: "Legal y trazado", desc: "Cada paso documentado: foto, firma, geolocalización, parte legal." },
          { title: "Red europea propia", desc: "27 países, transportistas verificados, sin subcontratas opacas." },
          { title: "Confidencialidad total", desc: "Acuerdos NDA, equipo discreto y sin filtración pública." },
          { title: "Coste cerrado", desc: "Tarifa por caso, sin sorpresas. Cotización personalizada para cada expediente." }
        ]
      },
      faq: {
        tagline: "PREGUNTAS FRECUENTES",
        title: "Lo que preguntan financieras y concesionarios.",
        items: [
          { q: "¿Cuánto tarda la recuperación?", a: "Activamos en menos de 24h. La localización media es <48h y la recuperación efectiva varía según el país y la situación legal del vehículo." },
          { q: "¿Cuál es vuestro procedimiento legal?", a: "Trabajamos siempre con expediente abierto, mediación previa y custodia documental completa. Toda la operativa queda documentada en informe PDF con fotos y firmas." },
          { q: "¿Operáis fuera de España?", a: "Sí. Tenemos red activa en los 27 países de la UE más Reino Unido, Suiza y Noruega. Gestionamos toda la documentación transfronteriza." },
          { q: "¿Cómo se factura el servicio?", a: "Cotización cerrada por expediente, personalizada según el caso. Sin costes ocultos. Tarifa especial para volumen recurrente B2B." },
          { q: "¿Es totalmente confidencial?", a: "Firmamos NDA con todos nuestros clientes B2B. Nada del expediente sale del equipo asignado." }
        ]
      },
      form: {
        tagline: "ACTIVAR EXPEDIENTE",
        title: "Activa tu caso de recuperación.",
        subtitle: "Recibirás cotización cerrada y plan de acción personalizado.",
        company: "Empresa",
        companyPlaceholder: "Nombre de tu empresa",
        name: "Persona de contacto",
        namePlaceholder: "Tu nombre",
        email: "Email corporativo",
        emailPlaceholder: "tu@empresa.com",
        phone: "Teléfono",
        phonePlaceholder: "+34 ...",
        caseType: "Tipo de caso",
        caseTypePlaceholder: "Alquiler no devuelto, final de contrato, recogida urgente…",
        location: "Última ubicación conocida",
        locationPlaceholder: "Ciudad, país o matrícula",
        urgency: "Urgencia",
        urgencyOptions: ["Inmediata (24h)", "Esta semana", "Sin urgencia"],
        notes: "Detalles del caso",
        notesPlaceholder: "Cuéntanos brevemente la situación. NDA garantizado.",
        submit: "Activar recuperación",
        whatsapp: "Activar por WhatsApp",
        nda: "Caso confidencial · NDA garantizado",
        successTitle: "Caso recibido.",
        successDescription: "Tu gestor dedicado abrirá expediente en menos de 24h. Te llamaremos al teléfono indicado.",
        errorTitle: "Error",
        errorDescription: "No hemos podido recibir tu caso. Inténtalo de nuevo o por WhatsApp."
      }
    }
  },
  en: {
    nav: {
      tech: "Logistics",
      services: "Services",
      recovery: "Recovery",
      corporate: "Fleets",
      howItWorks: "How it works",
      faq: "FAQ",
      contact: "Contact",
      callNow: "Get a quote",
      login: "Team login"
    },
    topBanner: "AutoGo System · Premium Recovery 24/7",
    hero: {
      tagline: "AUTOGO SYSTEM",
      title: "Vehicle transport,",
      titleHighlight: "elevated.",
      description: "Precision logistics, real-time tracking and ironclad delivery for your vehicle across Spain and Europe.",
      verified: "Verified carriers",
      insured: "Full-risk insurance",
      delivery: "24-72h delivery",
      formTitle: "Quote in 30 seconds",
      formSubtitle: "Human reply in under 15 minutes",
      pickupLocation: "Origin",
      pickupPlaceholder: "Pickup city",
      deliveryLocation: "Destination",
      deliveryPlaceholder: "Delivery city",
      pickupDate: "Pickup date",
      deliveryDate: "Delivery date",
      vehicleType: "Vehicle",
      vehiclePlaceholder: "Car, van, SUV…",
      name: "Name",
      namePlaceholder: "Your name",
      email: "Email",
      emailPlaceholder: "you@email.com",
      phone: "Phone",
      phonePlaceholder: "+34 930 49 15 01",
      submit: "Request quote",
      whatsappBtn: "Quote via WhatsApp",
      successTitle: "Request sent!",
      successDescription: "We will reach you in under 15 minutes with your custom quote.",
      errorTitle: "Error",
      errorDescription: "There was a problem sending your request. Please try again or message us on WhatsApp.",
      dateOrderErrorTitle: "Check your dates",
      dateOrderErrorDescription: "Delivery must be on the same day as pickup or later."
    },
    miniMockup: {
      route: "Active route",
      eta: "ETA",
      etaTime: "14:30",
      weather: "Sunny · 22°C",
      city1: "Madrid",
      city2: "Barcelona",
      live: "LIVE"
    },
    dashboard: {
      tag: "MY DASHBOARD",
      greeting: "Hi, Carlos",
      client: "Client #4821",
      activeShipment: "Active shipment",
      shipmentRoute: "Madrid → Barcelona",
      progressLabel: "Progress",
      stages: ["Pickup", "In transit", "Delivery"],
      stageActive: 1,
      services: "Active services",
      svc1: "SmartTrack 360",
      svc2: "Inspection 360°",
      svc3: "SecurePIN",
      svc4: "Alerts",
      stat1: "Next delivery",
      stat1v: "Today 14:30",
      stat2: "Vehicles",
      stat2v: "1 in transit"
    },
    inspectionMock: {
      angles: ["FRONT", "LEFT", "RIGHT", "REAR"],
      report: "Report",
      reportData: "PDF · 24 photos",
      ready: "READY",
      status: "Vehicle status",
      statusOk: "3/4 OK",
      areas: [
        { area: "Body", ok: true },
        { area: "Glass", ok: true },
        { area: "Right door", ok: false },
        { area: "Wheels", ok: true }
      ],
      timeline: "Timeline",
      now: "Today · 14:30",
      stages: [
        { stage: "Pre-route", time: "12:30", done: true },
        { stage: "Loading", time: "12:45", done: true },
        { stage: "Post-route", time: "14:28", done: true },
        { stage: "Delivery", time: "Pending", done: false }
      ]
    },
    pinMock: {
      verified: "PIN verified",
      verifiedTime: "Today · 14:32",
      ok: "OK",
      receiver: "Carlos Martínez",
      receiverDoc: "ID ****12345"
    },
    differentiators: {
      tagline: "AUTOGO LOGISTICS",
      title: "We don't just transport.",
      titleAccent: "We monitor every kilometer.",
      subtitle: "Our own platform raises vehicle transport from standard to premium.",
      pillars: {
        track: {
          name: "SmartTrack 360",
          desc: "Live satellite tracking, exact ETA and weather at destination. Your car, always on screen.",
          tag: "TRACKING"
        },
        check: {
          name: "Inspection 360°",
          desc: "In-depth digital review before and after every route. Full visual documentation.",
          tag: "INSPECTION"
        },
        panel: {
          name: "Client Panel",
          desc: "All your operations in one place: active shipment, services and deliveries. 24/7 access.",
          tag: "DASHBOARD"
        },
        pin: {
          name: "SecurePIN Verification",
          desc: "Unique delivery code. Your vehicle is only released to whoever holds the PIN.",
          tag: "DELIVERY"
        },
        alerts: {
          name: "Proactive Alerts",
          desc: "Automatic notifications at every key milestone: pickup, route, arrival and delivery.",
          tag: "ALERTS"
        }
      }
    },
    services: {
      tagline: "WHAT WE DO",
      title: "Complete transport solutions.",
      list: [
        { title: "National Transport", desc: "Cars and vans anywhere in Spain. Full peninsular coverage." },
        { title: "International Transport", desc: "We move your vehicle to any European country with full guarantee and active tracking." },
        { title: "Fleet Transport", desc: "B2B solutions for companies, dealerships and financial firms with end-to-end management." },
        { title: "Premium Services", desc: "Pre-delivery cleaning, ITV handling and mechanical check-up before departure." }
      ]
    },
    operatingMargin: {
      tag: "FLEETS ONLY",
      ribbon: "FLEET PROGRAM",
      name: "Fleet Save",
      titleLine1: "Fleet",
      titleLine2: "Save.",
      slogan: "Turn your logistics into net profit.",
      description: "Locked rate and up to −10% direct savings on every transfer. One invoice. Zero extra hassle.",
      homeHeadline1: "Move more.",
      homeHeadline2: "Pay less.",
      homeWidgetLabel: "DIRECT SAVINGS",
      homeWidgetUpTo: "Up to",
      homeWidgetBig: "−10%",
      homeWidgetUnit: "GUARANTEED · ON EVERY TRANSFER",
      homeWidgetMoney: "≈ €4,280",
      homeWidgetMoneyLabel: "AVERAGE SAVINGS · TYPICAL FLEET · YTD",
      seal: "GUARANTEED SAVINGS",
      sealRotation: "FLEET • PROGRAM • PREMIUM • ",
      compareTitle: "Your margin, visualized",
      compareStandard: "Standard operations",
      compareOM: "With Fleet Save",
      compareNote: "Reference curve. Your proposal is 100% custom.",
      benefits: [
        { title: "Locked rate", desc: "Freeze your annual cost. No surprises." },
        { title: "Single invoice", desc: "Forget per-transport quotes." },
        { title: "Up to 10% savings", desc: "Direct, across our full network." },
        { title: "Full control", desc: "Dedicated manager and ops dashboard." }
      ],
      formTitle: "Request your proposal",
      formSubtitle: "You will receive a tailored plan within 24h.",
      cardLabel: "FLEET MEMBER",
      cardId: "OM • CORPORATE",
      company: "Company",
      companyPlaceholder: "Your company name",
      contactName: "Your name",
      contactNamePlaceholder: "Contact person",
      email: "Corporate email",
      emailPlaceholder: "you@company.com",
      phone: "Phone",
      phonePlaceholder: "+34 ...",
      annualKm: "Estimated annual volume",
      annualKmPlaceholder: "e.g. 50,000 km / 80 transports",
      notes: "Notes (optional)",
      notesPlaceholder: "Briefly tell us about your operations…",
      submit: "Request proposal",
      whatsapp: "Talk to sales",
      restricted: "ACCESS BY REQUEST · ACTIVE FLEETS ONLY",
      successTitle: "Request received",
      successDescription: "We'll send you a tailored proposal within 24h.",
      errorTitle: "Error",
      errorDescription: "We couldn't send your request. Please try again or contact us on WhatsApp."
    },
    fleetSaveLanding: {
      meta: {
        title: "Fleet Save — Save up to 10% on every transfer | AutoGo Delivery",
        description: "Exclusive Fleet Save program for dealerships, renting and corporate fleets. Up to -10% per transfer, single monthly invoice, dedicated 24/7 manager. Tailored proposal in 24h."
      },
      backHome: "Back to home",
      brandTag: "FLEET SAVE",
      topBanner: "Fleet Save Program · Direct savings up to -10% · Real save from the first day",
      navCta: "Request proposal",
      hero: {
        badge: "EXCLUSIVE PROGRAM · FLEETS",
        title: "Every transfer you",
        titleAccent1: "overpay",
        titleMiddle: "is margin you",
        titleAccent2: "lose.",
        description: "Fleet Save is AutoGo's program for companies with frequent transfers. One single monthly invoice, locked rate and up to 10% direct savings across our entire European network.",
        ctaPrimary: "Request proposal",
        ctaSecondary: "See how it works",
        trust: ["Real save from the first day", "Proposal in 24h", "NDA available"]
      },
      anchors: {
        tagline: "THREE NUMBERS THAT SUM IT UP",
        savingsUpTo: "Up to",
        items: [
          { v: "−10%", l: "Savings per transfer", d: "Applied directly from the first transfer across our full network." },
          { v: "1", l: "Monthly invoice", d: "A single invoice with all transfers. Forget per-trip quotes." },
          { v: "24/7", l: "Dedicated manager", d: "A single contact who knows your operations and replies with no delays." }
        ]
      },
      calc: {
        tagline: "SAVINGS CALCULATOR",
        title: "Calculate your savings",
        titleAccent: "in 10 seconds.",
        subtitle: "Move the sliders with your real operations and see the margin you could recover this year.",
        transfersLabel: "Transfers per month",
        transfersHint: "Your fleet's historical average",
        kmLabel: "Average distance (km)",
        kmHint: "Per transfer · one way",
        outputLabel: "Estimated annual savings",
        outputUnit: "EUR / YEAR",
        outputDetail: "That's",
        outputDetailSuffix: "€ per month of direct savings.",
        note: "Indicative calculation. Your final proposal is 100% customized to route, vehicle and volume.",
        ctaSecondary: "Talk on WhatsApp",
        ctaPrimary: "Request my proposal",
        monthlyTransfers: "transfers / month",
        kmShort: "km"
      },
      how: {
        tagline: "HOW IT WORKS",
        title: "Three steps.",
        titleAccent: "Zero operational friction.",
        subtitle: "Simplify your internal processes",
        steps: [
          { num: "01", title: "You request a proposal", desc: "Tell us volume, typical routes and vehicles. In 24h we send a tailored plan.", bullets: ["24h proposal", "No commitment", "NDA access"] },
          { num: "02", title: "You activate your km credit", desc: "Lock your annual rate and activate your credit. Your team keeps operating as usual.", bullets: ["Locked rate", "48h setup", "Dedicated manager"] },
          { num: "03", title: "You use it and invoice monthly", desc: "Your team books transfers as normal. One consolidated invoice per month.", bullets: ["One invoice", "Usage panel", "Per-unit reporting"] }
        ]
      },
      forWho: {
        tagline: "WHO IT'S FOR",
        title: "Built for those who move",
        titleAccent: "cars every month.",
        list: [
          { title: "Dealerships", desc: "Stock rotation between branches, deliveries to end customers and ex-demo pickups." },
          { title: "Renting & Leasing", desc: "Activations, terminations and driver changes with pickups and deliveries across Europe." },
          { title: "Corporate fleets", desc: "Large companies with recurring transfers of company cars, executive vehicles or workshop units." }
        ]
      },
      cardSection: {
        tagline: "THE PRODUCT IN REAL USE",
        title: "This is how your team",
        titleAccent: "sees the program each month.",
        subtitle: "Real-time Fleet Member card: accumulated savings, transfers consumed of the plan and locked rate.",
        bullets: [
          "Panel accessible 24/7 by your authorized team",
          "Exportable to your ERP or management system",
          "Consolidated monthly PDF report"
        ]
      },
      testimonials: {
        tagline: "WHAT OUR FLEETS SAY",
        title: "Real results,",
        titleAccent: "not theory.",
        items: [
          {
            quote: "With Fleet Save we went from 40 monthly quotes to one consolidated invoice. The admin time savings alone justify the program — and we also cut 9% on transfer cost.",
            name: "María L.",
            role: "Operations Director",
            company: "Dealership group · Catalonia"
          },
          {
            quote: "We move 60-80 cars a month in renting. Moving to AutoGo with Fleet Save gave us cost predictability and a manager who knows our processes. Zero surprises.",
            name: "Javier R.",
            role: "Fleet Manager",
            company: "B2B Renting · Madrid"
          }
        ],
        note: "Real testimonials. Full company details available under NDA during the call."
      },
      form: {
        tagline: "REQUEST PROPOSAL",
        title: "Get your proposal",
        titleAccent: "in 24 hours.",
        subtitle: "Five fields. No commitment. Tailored plan for your real volume.",
        company: "Company",
        companyPlaceholder: "Your company name",
        name: "Contact person",
        namePlaceholder: "Your name",
        email: "Corporate email",
        emailPlaceholder: "you@company.com",
        phone: "Phone",
        phonePlaceholder: "+34 ...",
        monthlyTransfers: "Approximate transfers per month",
        monthlyTransfersPlaceholder: "e.g. 25",
        submit: "Get my proposal in 24h",
        whatsapp: "Talk to sales on WhatsApp",
        nda: "Guaranteed confidentiality · NDA available",
        successTitle: "Proposal on the way",
        successDescription: "A manager will review your case and call you in under 24h with your tailored plan.",
        errorTitle: "Error",
        errorDescription: "We couldn't send your request. Please try again or contact us on WhatsApp."
      }
    },
    recovery: {
      badge: "SPECIAL OPERATIONS · 24/7",
      title: "Vehicle recovery",
      titleAccent: "across Europe.",
      description: "European leaders in professional vehicle recovery and transfer: unreturned rentals, end-of-contract pickups and complex situations. Legal, discreet, effective.",
      points: [
        { title: "B2B Returns", desc: "Recovery of units pending return with full documented custody." },
        { title: "Unreturned rental", desc: "Location and recovery in any European country." },
        { title: "European Coverage", desc: "International network of specialized professionals." }
      ],
      btn1: "Urgent Recovery",
      btn2: "Confidential consultation",
      stats: [
        { v: "24/7", l: "Availability" },
        { v: "100%", l: "Legal" },
        { v: "EU", l: "Coverage" }
      ]
    },
    howItWorks: {
      tagline: "HOW IT WORKS",
      title: "Four steps.",
      titleAccent: "Zero friction.",
      subtitle: "A flow designed so all you have to do is confirm and receive.",
      steps: [
        { num: "01", title: "Quote", desc: "Transparent pricing in minutes.", bullets: ["Reply < 15 min", "No commitment", "Web or WhatsApp"] },
        { num: "02", title: "Pre-Check", desc: "360° inspection and coordinated pickup.", bullets: ["360° photos", "Visual documentation", "Door-to-door pickup"] },
        { num: "03", title: "In transit", desc: "Active tracking and real-time alerts.", bullets: ["Satellite GPS", "Exact ETA + weather", "Proactive alerts"] },
        { num: "04", title: "Delivery", desc: "SecurePIN validation and full documentation.", bullets: ["Unique delivery PIN", "Digital signature", "Final PDF report"] }
      ]
    },
    stats: {
      vehicles: "10K+",
      vehiclesLabel: "Vehicles delivered",
      satisfaction: "98%",
      satisfactionLabel: "Satisfied customers",
      delivery: "24-72h",
      deliveryLabel: "Average delivery time",
      coverage: "EU",
      coverageLabel: "International coverage"
    },
    clients: {
      tagline: "TRUSTED BY",
      subtitle: "Dealerships · Finance · Insurance · Renting"
    },
    quickAccess: {
      tagline: "QUICK ACCESS",
      title: "What do you need today?",
      cards: [
        {
          tag: "24/7 OPERATIONS · EUROPE",
          title: "Vehicle",
          highlight: "Recovery",
          desc: "Premium service for finance firms, leasing and dealerships. Legal procedure across Europe.",
          cta: "See Recovery",
          to: "/recuperacion",
          featured: true
        },
        {
          tag: "TRANSPORT",
          title: "Standard &",
          highlight: "Premium",
          desc: "Cars, vans and SUVs. National and international coverage with active tracking.",
          cta: "Get a quote",
          to: "#hero"
        },
        {
          tag: "B2B FLEETS",
          title: "Fleet",
          highlight: "Save",
          desc: "Exclusive program with up to 10% savings and locked rates for volume.",
          cta: "See Fleet Save",
          to: "/flotas",
          discount: "−10%",
          discountLabel: "SAVINGS"
        }
      ]
    },
    additional: {
      tagline: "EXTRAS",
      title: "More than transport.",
      list: [
        { title: "ITV & Homologation", desc: "We handle ITV before transport." },
        { title: "Full Cleaning", desc: "Your vehicle delivered like new." },
        { title: "Tech Pit Stop", desc: "Levels, pressure, lights and brakes checked." },
        { title: "Representations", desc: "For financial firms and dealerships." }
      ]
    },
    faq: {
      tagline: "FREQUENTLY ASKED",
      title: "What you need to know.",
      subtitle: "Clear and direct answers. If yours isn't here, message us.",
      contactBtn: "Message us on WhatsApp"
    },
    footer: {
      description: "Premium vehicle transport and recovery across Spain and Europe.",
      quickLinks: "Navigation",
      contact: "Contact",
      legal: "Legal",
      whatsapp: "WhatsApp",
      rights: "© 2025 AutoGo Delivery · All rights reserved.",
      privacyPolicy: "Privacy Policy",
      cookiesPolicy: "Cookies Policy"
    },
    recoveryLanding: {
      meta: {
        title: "Vehicle recovery across Europe | AutoGo Delivery",
        description: "Premium vehicle recovery and transfer service: leasing, unreturned rentals and end-of-contract pickups. Legal, discreet and effective procedure across Europe. 24/7."
      },
      backHome: "Back to home",
      hero: {
        badge: "SPECIAL OPS · 24/7 · EUROPE",
        title: "Vehicle recovery",
        titleAccent: "without legal friction.",
        description: "The service finance firms, dealerships, leasing, renting and insurers choose to locate and recover vehicles across Europe. Legal, discreet, tracked in real time.",
        ctaPrimary: "Activate urgent recovery",
        ctaSecondary: "Talk on WhatsApp",
        trust: ["100% Legal", "EU coverage", "Photo & signature reports", "Available 24/7"]
      },
      stats: [
        { v: "24/7", l: "Instant activation" },
        { v: "27", l: "Countries with active network" },
        { v: "<48h", l: "Average recovery time" },
        { v: "100%", l: "Legal procedure" }
      ],
      forWho: {
        tagline: "FOR WHOM",
        title: "Built for those who",
        titleAccent: "can't wait.",
        list: [
          { title: "Finance firms", desc: "Recovery and safe transfer of units anywhere in Europe, with full documented custody." },
          { title: "Dealerships", desc: "Demo vehicles, operating leasing or unsettled sales." },
          { title: "Renting & Leasing", desc: "European location of overdue or unreturned units." },
          { title: "Insurers", desc: "Crashed, stolen or pending-appraisal vehicles." }
        ]
      },
      cases: {
        tagline: "WHEN TO CALL US",
        title: "Cases we solve daily.",
        items: [
          { tag: "URGENT PICKUP", title: "Urgent B2B pickup", desc: "Location and pickup with critical deadline anywhere in Europe, with full documented custody." },
          { tag: "RENTAL", title: "Unreturned renting/rental", desc: "Search across any European country and safe transfer to your HQ or stock." },
          { tag: "END OF CONTRACT", title: "End of leasing/renting", desc: "Scheduled pickup at contract end and transfer to your HQ or stock with full report." },
          { tag: "EU FUGITIVE", title: "Vehicle outside Spain", desc: "Network of certified partners across 27 EU countries for cross-border handling." }
        ]
      },
      how: {
        tagline: "HOW IT WORKS",
        title: "From call to recovery.",
        titleAccent: "In 4 phases.",
        steps: [
          { num: "01", title: "Activation", desc: "We receive the case 24/7 and open a file with your dedicated manager." },
          { num: "02", title: "Location", desc: "Our European network locates the vehicle and verifies legal status." },
          { num: "03", title: "Recovery", desc: "Field operation anywhere in Europe with full documented custody." },
          { num: "04", title: "Delivery", desc: "Safe transfer to your HQ, stock or depot with full traceable report." }
        ]
      },
      whyUs: {
        tagline: "WHY AUTOGO",
        title: "No one recovers like AutoGo.",
        points: [
          { title: "Legal & traceable", desc: "Every step documented: photo, signature, geolocation, legal report." },
          { title: "Own European network", desc: "27 countries, verified carriers, no opaque subcontracting." },
          { title: "Total confidentiality", desc: "NDAs, discreet team, no public leaks." },
          { title: "Closed pricing", desc: "Per-case fee, no surprises. Tailored quote for each file." }
        ]
      },
      faq: {
        tagline: "FREQUENTLY ASKED",
        title: "What finance firms and dealerships ask.",
        items: [
          { q: "How long does recovery take?", a: "We activate in under 24h. Average location is <48h and effective recovery varies depending on country and vehicle's legal status." },
          { q: "What is your legal procedure?", a: "We always work with an open file, prior mediation and full documented custody. Every step is documented in a PDF report with photos and signatures." },
          { q: "Do you operate outside Spain?", a: "Yes. We have an active network across the 27 EU countries plus the UK, Switzerland and Norway. We handle all cross-border paperwork." },
          { q: "How is the service billed?", a: "Closed quote per file, tailored to each case. No hidden costs. Special tariff for recurring B2B volume." },
          { q: "Is it fully confidential?", a: "We sign NDAs with all B2B clients. Nothing from the file leaves the assigned team." }
        ]
      },
      form: {
        tagline: "ACTIVATE FILE",
        title: "Activate your recovery case.",
        subtitle: "You'll receive a closed quote and tailored action plan.",
        company: "Company",
        companyPlaceholder: "Your company name",
        name: "Contact person",
        namePlaceholder: "Your name",
        email: "Corporate email",
        emailPlaceholder: "you@company.com",
        phone: "Phone",
        phonePlaceholder: "+34 ...",
        caseType: "Case type",
        caseTypePlaceholder: "Unreturned rental, end of contract, urgent pickup…",
        location: "Last known location",
        locationPlaceholder: "City, country or plate",
        urgency: "Urgency",
        urgencyOptions: ["Immediate (24h)", "This week", "Not urgent"],
        notes: "Case details",
        notesPlaceholder: "Briefly tell us the situation. NDA guaranteed.",
        submit: "Activate recovery",
        whatsapp: "Activate via WhatsApp",
        nda: "Confidential case · NDA guaranteed",
        successTitle: "Case received.",
        successDescription: "Your dedicated manager will open the file in under 24h and call you on the phone provided.",
        errorTitle: "Error",
        errorDescription: "We couldn't receive your case. Please try again or contact us via WhatsApp."
      }
    }
  }
};
